import { render, staticRenderFns } from "./PageInvoiceService.vue?vue&type=template&id=172e2948&scoped=true"
import script from "./PageInvoiceService.vue?vue&type=script&lang=js"
export * from "./PageInvoiceService.vue?vue&type=script&lang=js"
import style0 from "./PageInvoiceService.vue?vue&type=style&index=0&id=172e2948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e2948",
  null
  
)

export default component.exports